<template lang="pug">
div
    BaseHeader(
        :titulo='$t("mensagens.gerenteTerritorial.labels.titulo")',
        :voltarPara='{ route: "ConfiguracaoRastreabilidade" }',
        icon='el-icon-plus',
        :btnTexto='$t("mensagens.gerenteTerritorial.labels.novoGerente")',
        :exibeBotao='true',
        @btnHeaderClicado='goToCadastroGerenteTerritorial'
    )
    .bloco-gerentesTerritoriais
        .bloco-input
            .bloco-input__icon
                i.el-icon-search
            .bloco-input__input
                input.input-search(
                    v-model='filtro',
                    type='text',
                    :placeholder='$t("mensagens.gerenteTerritorial.labels.placeholder")',
                    autocomplete='off',
                    @keyup.enter='buscargerentesTerritoriais(1)'
                )
        .bloco-listagem-gerentesTerritoriais
            h3 {{ $t('mensagens.gerenteTerritorial.labels.listagem') }}
            el-table(:key="listagemTableKey('gerentes-territoriais', gerentesTerritoriais, paginacao.pagina + 1)", :data='gerentesTerritoriais')
                el-table-column(
                    prop='id',
                    label='ID ERP',
                    width='200',
                    align='center'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.idBunge || '-' }}
                el-table-column(
                    prop='nome',
                    :label='$t("mensagens.gerenteTerritorial.labels.nomeLabel")'
                )
                    template(slot-scope='scope')
                        span {{ scope.row.nome || '-' }}

                el-table-column(
                    :label='$t("mensagens.gerenteTerritorial.labels.acao")',
                    :min-width='15',
                    align='center'
                )
                    .template(slot-scope='scope')
                        el-dropdown.action-button(trigger='click')
                            span.el-dropdown-link
                                i.mdi.mdi-dots-vertical
                            el-dropdown-menu(slot='dropdown')
                                el-dropdown-item(
                                    icon='el-icon-view',
                                    @click.native='irParaDetalhesGerenteTerritorial(scope.row, true)'
                                ) {{ $t('mensagens.gerenteTerritorial.labels.visualizar') }}
                                el-dropdown-item(
                                    icon='el-icon-edit',
                                    @click.native='goToEditarGerenteTerritorial(scope.row)'
                                ) {{ $t('mensagens.gerenteTerritorial.labels.editar') }}
                                el-dropdown-item(
                                    icon='el-icon-delete',
                                    @click.native='removerGerenteTerritorial(scope.row)'
                                ) {{ $t('mensagens.gerenteTerritorial.labels.excluir') }}
                template(slot='empty')
                el-empty(description='Não há fornacedores')
            .bloco-paginacao
                span {{ paginacao.total }} {{ paginacao.total > 1 ? $t('mensagens.gerenteTerritorial.labels.titulo') : $t('mensagens.gerenteTerritorial.labels.tituloSingular') }}
                el-pagination(
                    background,
                    :page-size='paginacao.itensPorPagina',
                    :current-page.sync='paginacao.pagina + 1',
                    layout='prev, pager, next',
                    :total='paginacao.total',
                    @current-change='mudarPagina'
                )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import ContratoOriginacaoService from '@/services/ContratoOriginacaoService';

export default {
    name: 'ConfiguracaoGerentesTerritoriais',
    components: {
        BaseHeader
    },
    data() {
        return {
            filtro: '',
            pageable: {
                page: 0,
                size: 10,
                sort: 'nome',
                order: 'asc'
            },
            gerentesTerritoriais: [],
            paginacao: {}
        };
    },
    mounted() {
        this.buscargerentesTerritoriais(1);
    },
    methods: {
        async buscargerentesTerritoriais(page) {
            this.pageable.page = page - 1;
            const { data } =
                await ContratoOriginacaoService.buscarGerentesTerritoriaisPorFiltro(
                    { nome: this.filtro },

                    this.pageable
                );
            this.gerentesTerritoriais = data.gerentesTerritoriais;
            this.paginacao = data.paginacao;
        },

        mudarPagina(page) {
            this.buscargerentesTerritoriais(page);
        },
        async removerGerenteTerritorial(row) {
            const result = await this.$messageBox.confirm(
                this.$t('mensagens.sistema.removerGerenteTerritorial'),
                this.$t('mensagens.comuns.aviso'),
                {
                    confirmButtonText: this.$t('mensagens.comuns.sim'),
                    cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                    type: 'warning'
                }
            );
            if (result === 'confirm') {
                try {
                    const payload = this.montarPayload(row);
                    const { data } =
                        await ContratoOriginacaoService.removerGerenteTerritorial(
                            payload
                        );
                    if (data.includes('sucesso')) {
                        this.$notify.success(
                            this.$t(
                                'mensagens.gerenteTerritorial.labels.registroExcluido'
                            )
                        );
                    }

                    this.buscargerentesTerritoriais(1);
                } catch (error) {}
            }
        },
        goToCadastroGerenteTerritorial(row) {
            this.$router.push({
                name: 'CadastroGerenteTerritorial'
            });
        },
        goToEditarGerenteTerritorial(row) {
            this.$router.push({
                name: 'EditarGerenteTerritorial',
                params: { row: row }
            });
        },
        irParaDetalhesGerenteTerritorial(row) {
            this.$router.push({
                name: 'DetalhesGerenteTerritorial',
                params: { resume: row }
            });
        },
        montarPayload(row) {
            return {
                nome: row.nome,
                id: row.id
            };
        }
    }
};
</script>

<style lang="scss">
.bloco-gerentesTerritoriais {
    margin: 20px;
}

.bloco-input {
    display: flex;
    background-color: $white;
    padding: 7px 10px;
    border-radius: $default-border-radius;
    gap: 5px;
    align-items: center;
    @include default-box-shadow();
}

.bloco-input__icon i {
    color: $primary;
}

.bloco-input__input {
    flex: 1;

    input {
        border: 0 !important;
        outline: 0;
        width: 100%;
    }
}

.bloco-listagem-gerentesTerritoriais {
    margin-top: 20px;

    h3 {
        margin-bottom: 5px;
    }

    .el-table {
        border-radius: 4px 4px 0 0;
        @include default-box-shadow();
    }
}

.bloco-lista-cpf-cnpj {
    margin-left: 20px;
    display: flex;
    flex-direction: column;

    label {
        font-weight: bold;
    }

    ul {
        margin: 5px 0 0 0;
        padding: 0;
        list-style: none;

        li {
            padding: 7px;
            border-top: 1px solid #f0f2f7;
            font-size: 12px;
        }
    }
}

.bloco-paginacao {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background-color: $white;
    border-radius: 0 0 4px 4px;
    padding: 15px;

    span {
        color: $primary;
        font-weight: bold;
    }
}
</style>
